import * as types from '../types/order';
import * as api from '../constants/';
import axios from 'axios';

function setOrder(data) {
  return {
    type: types.ORDER_FETCH,
    data: data,
  };
}

function orderCreated() {
  return {
    type: types.ORDER_CREATED,
  };
}

function setReorder(data) {
  return {
    type: types.ORDER_FETCH_REORDER,
    data: data,
  }
}

export function createOrder(data) {
  return dispatch => {
    return axios.post(api.ORDER_URL, data).then((response) => {
      dispatch(orderCreated());
      return Promise.resolve(response);
    });
  };
}

export function getOrders(data) {
  return dispatch => {
    return axios.get(api.ORDER_URL, {
      params: data
    }).then(response => {
      return dispatch(setOrder(response.data));
    });
  }
}

export function getOrdersForReorder(data) {
  return dispatch => {
    return axios.get(api.CUSTOMER_REORDER_URL, {
      params: data
    }).then(response => {
      return dispatch(setReorder(response.data));
    });
  }
}

export function startFetchOrders() {
  return dispatch => {
    dispatch({
      type: types.ORDER_START_FETCH,
    });
  };
}

export function endFetchOrders() {
  return dispatch => {
    dispatch({
      type: types.ORDER_END_FETCH,
    });
  };
}


// WEBPACK FOOTER //
// ./src/actions/orderActions.js